import { render, staticRenderFns } from "./Bridge.vue?vue&type=template&id=4a34e990&scoped=true&"
import script from "./Bridge.vue?vue&type=script&lang=js&"
export * from "./Bridge.vue?vue&type=script&lang=js&"
import style0 from "./Bridge.vue?vue&type=style&index=0&id=4a34e990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a34e990",
  null
  
)

export default component.exports